import { useLayoutEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';

import { trackPageView } from '@snowplow/browser-tracker';

import { datadogLogs } from '@datadog/browser-logs';
import { ErrorBoundary } from '@datadog/browser-rum-react';

import {
  Content,
  SessionModeProvider,
  StartSplash,
  THEMES,
  ThemeProvider,
  VehicleProvider,
} from '@motorway/motorway-handshake-components';

import { Auth } from './api/Auth';
import { Connection } from './components/Connection/Connection';
import { DatadogVehicle } from './components/DatadogVehicle/DatadogVehicle';
import { FetchWrapperComponent } from './components/FetchWrapper/FetchWrapper';
import { ReportWrapperComponent } from './components/ReportWrapper/ReportWrapper';
import { Snowplow } from './components/Snowplow/Snowplow';
import { WebSocketsWrapper } from './components/WebSocketsWrapper/WebSocketsWrapper';
import { DriverProvider } from './contexts/Driver';
import { Home } from './pages/Home/Home';
import { Routes } from './pages/Routes/Routes';

import '@THC/styles/reset.scss';
import '@THC/styles/fontface.scss';
import '@THC/styles/base.scss';
import './Theme.scss';

import styles from './App.module.scss';

const ResetScroll = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    trackPageView();
    datadogLogs.logger.info('Page view', { path: location.pathname });
  }, [location.pathname]);

  return null;
};

export const App = () => (
  <ErrorBoundary fallback={() => <Home error />}>
    <ThemeProvider initialTheme={THEMES.DARK}>
      <Content className={styles.app}>
        <Snowplow />
        <DriverProvider>
          <FetchWrapperComponent>
            <VehicleProvider>
              <WebSocketsWrapper>
                <SessionModeProvider>
                  <ReportWrapperComponent>
                    <BrowserRouter>
                      <Auth />
                      <ResetScroll />
                      <Routes />
                      <DatadogVehicle />
                    </BrowserRouter>
                    <Connection />
                  </ReportWrapperComponent>
                </SessionModeProvider>
                <StartSplash />
              </WebSocketsWrapper>
            </VehicleProvider>
          </FetchWrapperComponent>
        </DriverProvider>
      </Content>
    </ThemeProvider>
  </ErrorBoundary>
);
